<template>
  <div class="navigation pl-4 pr-4 pt-3 pb-3 mb-2">
    <ul>
      <li>
        <router-link class="brand" to="/">
          <img src="../../assets/logo.svg" width="150" />
        </router-link>
      </li>
    </ul>
    <ul>
      <li v-if="isProfileLoaded">
        <router-link to="/account">{{ name }}</router-link>
      </li>
      <li v-if="isAuthenticated" @click="logout">
        <span class="logout">Ausloggen</span>
      </li>
      <li v-if="!isAuthenticated && !authLoading">
        <router-link to="/login">Einloggen</router-link>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
a {
  color: white;
  text-decoration: none;
}
  .navigation {
    display: flex;
    color: #2e426b;
    align-items: center;
    background-color: #e0e0e0; 
    font-size: 1.1rem;
    font-weight: 300;

    ul {
    display: flex;
    &:first-child {
      flex-grow: 1;
    }
    li {
      padding-right: 1em;
    }
    a {
    color: #2e426b;
    }
  }
}
.brand {
  display: flex;
  align-items: center;
}
.logout {
  &:hover {
    cursor: pointer;
  }
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import { AUTH_LOGOUT } from "actions/auth";

export default {
  name: "navigation",
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    }
  },
  computed: {
    ...mapGetters(["getProfile", "isAuthenticated", "isProfileLoaded"]),
    ...mapState({
      authLoading: state => state.auth.status === "loading",
      name: state => `${state.user.profile.name}`
    })
  }
};
</script>
